import { t } from "i18next";
import { useContext } from "react";
import { ConfigurationContext, WindowContext } from "../../App.js";
import { changeWallHeight, changeWallWidth } from "../../utils/Utils.js";
import Slider from "../Slider/Slider.js";

function SectionWindowSize(props) {
  const { setCurrentConfiguration } = useContext(ConfigurationContext);
  const { currentWindow } = useContext(WindowContext);

  const changedWidthValue = function (ev) {
    const newValue = ev.target.value / 100;
    const formattedValue = changeWallWidth(newValue, currentWindow);

    setCurrentConfiguration((prevState) => {
      return {
        wall: {
          ...prevState.wall,
          originalWidth: newValue,
          width: formattedValue,
        },
        window: {
          ...prevState.window,
        },
      };
    });
  };

  const changedHeightValue = function (ev) {
    const newValue = ev.target.value / 100;
    const formattedValue = changeWallHeight(newValue, currentWindow);

    setCurrentConfiguration((prevState) => {
      return {
        wall: {
          ...prevState.wall,
          originalHeight: newValue,
          height: formattedValue,
        },
        window: {
          ...prevState.window,
        },
      };
    });
  };

  return (
    <section className="panel-section">
      <div className="section-header section">{t("window_size")}</div>
      <div className="line"></div>
      <Slider
        id={"width"}
        title={t("width")}
        inputTitle={props.widthInputTitle}
        min={props.widthMin}
        max={props.widthMax}
        step={props.widthStep}
        value={props.widthValue}
        unit={props.widthUnit}
        editable={props.widthEditable}
        onChange={changedWidthValue}
      />
      <div className="section__space-between-sliders" />
      <Slider
        id={"height"}
        title={t("height")}
        inputTitle={props.heightInputTitle}
        min={props.heightMin}
        max={props.heightMax}
        step={props.heightStep}
        value={props.heightValue}
        unit={props.heightUnit}
        editable={props.heightEditable}
        onChange={changedHeightValue}
      />
    </section>
  );
}

export default SectionWindowSize;
